var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.jumpUrl($event)}}},[_c('img',{attrs:{"src":"https://cdncos.aigupiao.com/assets/app/toSign.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }